<!-- SuperAdminLayout.vue -->
<template>
  <div>
    <div class="container-scroller super-admin-shell" :class="{ 'sidebar-icon-only': isSidebarCollapsed }">
      <Headerr @toggleSidebar="toggleSidebar" />
      <div class="container-fluid page-body-wrapper">
        <Sidebar
          :isOpen="isSidebarOpen"
          :isCollapsed="isSidebarCollapsed"
          @close="closeSidebar"
          @toggleCollapse="toggleCollapse"
        />
        <div
          v-if="isSidebarOpen"
          class="sidebar-backdrop"
          @click="closeSidebar"
        ></div>
        <div class="main-panel">
          <router-view></router-view>
          <Footerr />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Headerr from "../components/superAdminLayout/Header.vue";
import Sidebar from "../components/superAdminLayout/Sidebar.vue";
import Footerr from "../components/superAdminLayout/Footer.vue";

export default {
  name: "SuperAdminLayout",
  components: { Headerr, Sidebar, Footerr },
  data() {
    return {
      isSidebarOpen: false,
      isSidebarCollapsed: localStorage.getItem("superAdminSidebarCollapsed") === "true",
    };
  },
  watch: {
    // Watch the route for changes
    $route() {
      // Close the sidebar on route change
      this.isSidebarOpen = false;
    },
    isSidebarOpen(isOpen) {
      // Lock body scroll while the mobile/tablet sidebar overlay is open
      document.body.classList.toggle("sidebar-open", isOpen);
    },
    isSidebarCollapsed(isCollapsed) {
      localStorage.setItem("superAdminSidebarCollapsed", isCollapsed);
    },
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },
    closeSidebar() {
      this.isSidebarOpen = false;
    },
    toggleCollapse() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
    },
    handleEscape(event) {
      if (event.key === "Escape") {
        this.closeSidebar();
      }
    },
  },
  mounted() {
    document.addEventListener("keydown", this.handleEscape);
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.handleEscape);
    document.body.classList.remove("sidebar-open");
  },
};
</script>

<style scoped>
.sidebar-backdrop {
  display: none;
}

@media (max-width: 991px) {
  .sidebar-backdrop {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 15, 20, 0.45);
    /* Above the fixed header (z-index 1030) so it dims the whole
       screen, but below the sidebar itself (1040) once open. */
    z-index: 1035;
    animation: sidebarBackdropFade 0.2s ease;
  }
}

@keyframes sidebarBackdropFade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
